import { render, staticRenderFns } from "./KpiChart.vue?vue&type=template&id=06b23e6d"
import script from "./KpiChart.vue?vue&type=script&lang=js"
export * from "./KpiChart.vue?vue&type=script&lang=js"
import style0 from "./KpiChart.vue?vue&type=style&index=0&id=06b23e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports